let bundleBuilderItems = [];
 
//first steps click event start here
jQuery(document).on("click",".pod_pickyour_pod .your-pod-button,.mob-your-pod-button",function(){
  var varaintId = jQuery(this).attr("data-variantid");
  //console.log("varaintId clicked",varaintId);
  jQuery('.main-product-text-image').removeClass("active");
  jQuery('.main-product-text-image').find('.podcta--primary').removeClass("selected");
  jQuery(this).find('.podcta--primary').addClass('selected');
  jQuery('.pod-products').find('.podcta-selected').hide();
  jQuery('.pod-products').find('.podcta-select').show();
  jQuery(this).find('.podcta-select').hide();
  jQuery(this).find('.podcta-selected').show();
  jQuery('.main-product-text-image.product_'+varaintId).addClass("active");
  selectedProductsData();
  //multipleSteps(1);
  if(jQuery('.bundle_navigation_section').find('.bundle_navigation_col.active-label[nav-steps="1"]').length==1){
    jQuery('.bundle-builder-footer-total').find('.footer-previous-button').hide();
  }
  //jQuery('.bundle-builder-footer-total').find('.footer-previous-button').show();
});
//first steps click event end here

//second steps click event start here
jQuery(document).on("click", ".desktop-cooling-options.cooling-product-quantity-card", function (e) {
  if (jQuery(this).parent("div:visible")) {
    jQuery('.cooling-product-chiler .main-product-text-image').removeClass("active");
    jQuery('.cooling-product-chiler .your-pod-button').removeClass("selected");
    var variantId = jQuery(this).attr("data-variantid");
    jQuery(".desktop-cooling-options.cooling-product-quantity-card").not(this).removeClass('selected');
    jQuery(this).toggleClass("selected")
    if(jQuery(this).hasClass("selected")) {
      jQuery(this).find(".cooling-label").addClass("active");
    } else {
      jQuery(this).find(".cooling-label").removeClass("active");
    }
    jQuery(".cooling-products").find(".your-pod-button").not(this).removeClass("selected");
    jQuery(".cooling-products").find(".your-pod-button").find(".podcta-select").show();
    jQuery(".cooling-products").find(".your-pod-button").find(".podcta-selected").hide();

    selectedProductsData();
  }
  e.preventDefault();
  e.stopPropagation();
  // multipleSteps(2);
});


/*jQuery(document).on("click",".cooling-products .your-pod-button",function(){
  jQuery('.cooling-product-quantity-card.selected').find(".cooling-label").removeClass("active");
  jQuery('.cooling-product-quantity-card.selected').find("[type='radio']").prop("checked",false);
  jQuery('.cooling-product-quantity-card.selected').removeClass("selected");
  jQuery('.pod_maintenance .no-chiller-product.selected').find("[type='radio']").prop("checked",false);
  jQuery('.pod_maintenance .no-chiller-product.selected').removeClass("selected");
  jQuery('.main-cooling-product-quantity').find('.cooling-product-quantity-card').removeClass("selected");
  var varaintId = jQuery(this).attr("data-variantid");
  jQuery('.cooling-products').find('.main-product-text-image').removeClass("active");
  jQuery('.cooling-products').find('.main-product-text-image').find('.your-pod-button').removeClass("selected");
  jQuery(this).addClass('selected');
  jQuery('.cooling-products').find('.podcta-selected').hide();
  jQuery('.cooling-products').find('.podcta-select').show();
  jQuery(this).find('.podcta-select').hide();
  jQuery(this).find('.podcta-selected').show();
  jQuery('.cooling-products').find('.main-product-text-image.product_'+varaintId).addClass("active");
  selectedProductsData();
  //multipleSteps(2);
});*/
//second steps click event end here

//third steps click event start here
/*jQuery(document).on("click",".main-chiller-product .chiller-product",function(e){
  var varaintId = jQuery(this).attr("data-variantid");
  jQuery('.bundle_builder_section .chiller-product').removeClass('selected');
  jQuery(this).addClass("selected");
  selectedProductsData();
  multipleSteps(3);
});*/
jQuery(document).on("change",".desktop-chiller-subscribe-purchase-three [name='chiller--switch']",function(){
  var varaintId = jQuery(this).attr("data-vid");
  var switchId = jQuery(this).parent().attr("data-switch");
  jQuery('.chiller-product-three').find('[name="one-chiller--switch"]').prop("checked",false);
  if(jQuery(this).prop("checked") == false){
    jQuery(this).prop("checked",false);
    //jQuery('.bundle_builder_section .chiller-product[data-variantid="'+varaintId+'"]').removeClass("selected");
    //jQuery('.desktop-chiller-subscribe-purchase-three .chiller-product[data-vid="'+varaintId+'"]').removeClass("selected");
  }
  else{
    jQuery('.bundle_builder_section .chiller-product[data-variantid="'+varaintId+'"]').addClass("selected");
    jQuery('.desktop-chiller-subscribe-purchase-three .chiller-product[data-vid="'+varaintId+'"]').addClass("selected");
    jQuery(this).prop("checked",true);
  }
  selectedProductsData();
});
jQuery(document).on("change",".desktop-chiller-subscribe-purchase-three [name='one-chiller--switch']",function(){
  var varaintId = jQuery(this).attr("data-vid");
  var switchId = jQuery(this).parent().attr("data-switch");

  jQuery('.chiller-product-three').find('[name="chiller--switch"]').prop("checked",false);
  if(jQuery(this).prop("checked") == false){
    jQuery(this).prop("checked",false);
    //jQuery('.bundle_builder_section .chiller-product[data-variantid="'+varaintId+'"]').removeClass("selected");
    //jQuery('.desktop-chiller-subscribe-purchase-three .chiller-product[data-vid="'+varaintId+'"]').removeClass("selected");
  }
  else{
    jQuery(this).prop("checked",true);
    jQuery('.bundle_builder_section .chiller-product[data-variantid="'+varaintId+'"]').addClass("selected");
    jQuery('.desktop-chiller-subscribe-purchase-three .chiller-product[data-vid="'+varaintId+'"]').addClass("selected");
  }
  selectedProductsData();
});


jQuery(document).on("change",".desktop-chiller-subscribe-purchase [name='chiller--switch']",function(){
  //jQuery('.desktop-chiller-subscribe-purchase [name="one-chiller--switch"]').prop("checked",false);
  var varaintId = jQuery(this).attr("data-vid");
  var switchId = jQuery(this).parent().attr("data-switch");
  jQuery('[data-switch="'+switchId+'"]').find('[name="one-chiller--switch"]').prop("checked",false);
  jQuery('.chiller-product.chiller-product-two.selected').find('[name="one-chiller--switch"]').prop("checked",false);
  jQuery('.chiller-product.chiller-product-two').addClass("selected");
  selectedProductsData();
  //multipleSteps(3);
});
jQuery(document).on("change",".desktop-chiller-subscribe-purchase [name='one-chiller--switch']",function(){
  //jQuery('.desktop-chiller-subscribe-purchase [name="chiller--switch"]').prop("checked",false);
  var varaintId = jQuery(this).attr("data-vid");
  var switchId = jQuery(this).parent().attr("data-switch");
  jQuery('[data-switch="'+switchId+'"]').find('[name="chiller--switch"]').prop("checked",false);
  jQuery('.chiller-product-two.selected').find('[name="chiller--switch"]').prop("checked",false);
  jQuery('.chiller-product.chiller-product-two').addClass("selected");
  selectedProductsData();
  //multipleSteps(3);
});

jQuery(document).on("change",".desktop-no-chiller-subscribe-purchase [name='chiller--switch']",function(){
  //jQuery('.desktop-no-chiller-subscribe-purchase [name="one-chiller--switch"]').prop("checked",false);
  var varaintId = jQuery(this).attr("data-vid");
  var switchId = jQuery(this).parent().attr("data-switch");
  jQuery('[data-switch="'+switchId+'"]').find('[name="one-chiller--switch"]').prop("checked",false);
  jQuery('.bundle_builder_section .no-chiller-product').removeClass('selected');
  jQuery('.no-chiller-product.selected').find('[name="one-chiller--switch"]').prop("checked",false);
  jQuery('.no-chiller-product.selected').find('[name="chiller--switch"]').prop("checked",false);
  if(jQuery(this).prop("checked") == false){
    jQuery(this).prop("checked",false);
  }
  else{
    jQuery(this).prop("checked",true);
  }
  jQuery('.bundle_builder_section .no-chiller-product[data-variantid="'+varaintId+'"]').addClass("selected");
  selectedProductsData();
  //multipleSteps(3);
});
jQuery(document).on("change",".desktop-no-chiller-subscribe-purchase [name='one-chiller--switch']",function(){
  //jQuery('.desktop-no-chiller-subscribe-purchase [name="chiller--switch"]').prop("checked",false);
  var varaintId = jQuery(this).attr("data-vid");
  var switchId = jQuery(this).parent().attr("data-switch");
  jQuery('[data-switch="'+switchId+'"]').find('[name="chiller--switch"]').prop("checked",false);
  jQuery('.bundle_builder_section .no-chiller-product').removeClass('selected');
  jQuery('.chiller-product.selected').find('[name="one-chiller--switch"]').prop("checked",false);
  jQuery('.chiller-product.selected').find('[name="chiller--switch"]').prop("checked",false);
  if(jQuery(this).prop("checked") == false){
    jQuery(this).prop("checked",false);
  }
  else{
    jQuery(this).prop("checked",true);
  }
  jQuery('.bundle_builder_section .no-chiller-product[data-variantid="'+varaintId+'"]').addClass("selected");
  selectedProductsData();
  //multipleSteps(3);
});

function accessoriesShow(index){
  jQuery('.pod_accessories').find('.accessori_product_col').removeClass('selected');
  jQuery('.pod_accessories').find('.accessori_product_col').hide();
  jQuery('.pod_accessories').find('.accessori_product_col.bundle_accessories_'+index).show();
  selectedProductsData();
}

//third steps click event end here

//fourth steps click event start here
jQuery(document).on("click",".bundle_accessories_section .ap_btn_box",function(){
  var varaintId = jQuery(this).find(".ap_btn_add").attr("data-variantid");
  //jQuery('.bundle_accessories_section .accessori_product_col').removeClass('selected');
  //console.log("check class",jQuery('.bundle_accessories_section .accessories_'+varaintId).hasClass('selected'));
  var podActiveIndex = jQuery('.pod-products').find('.main-product-text-image.active').attr('data-pod');
  console.log("podActiveIndex",podActiveIndex);
  if(jQuery('.bundle_accessories_section .bundle_accessories_'+podActiveIndex+'.accessories_'+varaintId).hasClass('selected')){
    jQuery('.bundle_accessories_section .bundle_accessories_'+podActiveIndex+'.accessories_'+varaintId).removeClass('selected');
    jQuery('.bundle_accessories_section .bundle_accessories_'+podActiveIndex+'.accessories_'+varaintId).find('.ap_btn_add').show();
    jQuery('.bundle_accessories_section .bundle_accessories_'+podActiveIndex+'.accessories_'+varaintId).find('.ap_btn_select').hide();
  }else{
    jQuery('.bundle_accessories_section .bundle_accessories_'+podActiveIndex+'.accessories_'+varaintId).find('.ap_btn_add').hide();
    jQuery('.bundle_accessories_section .bundle_accessories_'+podActiveIndex+'.accessories_'+varaintId).find('.ap_btn_select').show();
    jQuery('.bundle_accessories_section .bundle_accessories_'+podActiveIndex+'.accessories_'+varaintId).addClass('selected');
  }
  //jQuery('.bundle_accessories_section').find('.ap_btn_select').hide();
  //jQuery('.bundle_accessories_section').find('.ap_btn_add').show();
  selectedProductsData();
  //multipleSteps(4);
});
//fourth steps click event end here

/************** Mobile device start js ****************/
  //first steps click event start here
  jQuery(document).on("click",".pod-products .main-product-text-image",function(){
    var objPod = jQuery(this).find('.your-pod-button');
    var varaintId = objPod.attr("data-variantid");
    var indexGet=jQuery(this).attr('data-pod');
    //console.log("indexGet",indexGet);
    jQuery('.pod-products .main-product-text-image').removeClass("active");
    jQuery('.pod-products .main-product-text-image').find('.podcta--primary').removeClass("selected");
    jQuery('.pod-products .main-product-text-image').find('.podcta-select').show();
    jQuery('.pod-products .main-product-text-image').find('.podcta-selected').hide();
    jQuery(this).find('.podcta--primary').addClass('selected');
    jQuery(this).find('.podcta-select').hide();
    jQuery(this).find('.podcta-selected').show();
    jQuery('.main-product-text-image.product_'+varaintId).addClass("active");
    if(jQuery('.content-for-layout.bundle-builder').length>0){
      jQuery('.content-for-layout.bundle-builder').addClass('bb-steps-active');
    }
    selectedProductsData();
    accessoriesShow(indexGet);
    jQuery('.bundle-builder-footer-total .footer-next-button').removeClass('first_select_product');
    //multipleSteps(1);
  });
  //first steps click event end here
  
  //second steps click event start here
  jQuery(".mobile-cooling-options.cooling-product-quantity-card").click(function () {
      jQuery('.pod_cooling_option .main-product-text-image.active').removeClass("active");
      jQuery('.pod_cooling_option .your-pod-button.selected')
          .find('.podcta-select').show()
          .end()
          .find('.podcta-selected').hide()
          .end()
          .removeClass("selected");
      jQuery('.cooling-products').find('.your-pod-button').removeClass("selected");
      
      jQuery(".cooling-product-quantity-card").not(this).removeClass("selected");
      jQuery(".cooling-product-quantity-card").not(this).find('[type="radio"]').prop("checked", false);
      jQuery(this).toggleClass("selected");
      jQuery(".main-cooling-product-quantity").find('.cooling-product-quantity-card').removeClass("selected");
      var radioInput = jQuery(this).find('[type="radio"]');
      radioInput.prop("checked", jQuery(this).hasClass("active"));
      if (!jQuery(this).hasClass("active")) {
          jQuery(this).find('.cooling-label').removeClass("active");
      }
      selectedProductsData();
      // multipleSteps(2);
  });

  
  jQuery(document).on("click", ".cooling-product-chiler .main-product-text-image", function () {
    // Reset previously active elements
    jQuery(".cooling-product-chiler .main-product-text-image").not(this).removeClass("active").find('.podcta-select').show().end().find('.podcta-selected').hide();
    jQuery(".cooling-product-quantity-card").not(this).removeClass("selected").find("[type='radio']").prop("checked", false).end().find(".cooling-label").removeClass("active");
    jQuery(".pod_maintenance .no-chiller-product").not(this).removeClass("selected").find("[type='radio']").prop("checked", false);
    jQuery(".cooling-product-chiler .main-product-text-image").find(".your-pod-button").not(this).removeClass("selected");
    // Toggle the current element
    jQuery(this).toggleClass("active");
    
    // If active, adjust visibility and styles
    if (jQuery(this).hasClass("active")) {
      jQuery(this).find(".podcta-select").hide();
      jQuery(this).find(".podcta-selected").show();
      jQuery(this).find(".your-pod-button").addClass("selected");
    } else {
      jQuery(this).find(".podcta-select").show();
      jQuery(this).find(".podcta-selected").hide();
      jQuery(this).find(".your-pod-button").removeClass("selected");
    }
  
    // Additional actions
    const coolingObj = jQuery(this).find(".your-pod-button");
    const variantId = coolingObj.attr("data-variantid");
    
    // Call any related functions
    selectedProductsData();
    // multipleSteps(2); // Uncomment if needed
  });

  //second steps click event end here
  
  //third steps click event start here
  /*jQuery(document).on("click",".pod_maintenance .no-chiller-product",function(){
    var varaintId = jQuery(this).attr("data-variantid");
    console.log("varaintId",varaintId);
    jQuery('.pod_maintenance .no-chiller-product').removeClass('selected');
    jQuery(this).addClass("selected");
    selectedProductsData();
    multipleSteps(3);
  });*/
  //third steps click event end here

  jQuery(document).on("change",".mob-chiller-subscribe-purchase-three [name='chiller--switch']",function(){
    var varaintId = jQuery(this).attr("data-vid");
    jQuery('.chiller-product-three .mob-chiller-subscribe-purchase-three[name="one-chiller--switch"]').prop("checked",false);
    var varaintId = jQuery(this).attr("data-vid");
    jQuery('.bundle_builder_section .chiller-product-three[data-variantid="'+varaintId+'"]').addClass("selected");
    selectedProductsData();
  });
  jQuery(document).on("change",".mob-chiller-subscribe-purchase-three [name='one-chiller--switch']",function(){
    var varaintId = jQuery(this).attr("data-vid");
    jQuery('.chiller-product-three .mob-chiller-subscribe-purchase-three [name="chiller--switch"]').prop("checked",false);
    jQuery('.bundle_builder_section .chiller-product-three[data-variantid="'+varaintId+'"]').addClass("selected");
    selectedProductsData();
  });

  jQuery(document).on("change",".mob-chiller-subscribe-purchase [name='chiller--switch']",function(){
    jQuery('.mob-chiller-subscribe-purchase [name="one-chiller--switch"]').prop("checked",false);
    var varaintId = jQuery(this).attr("data-vid");
    //jQuery('.chiller-product.selected').find('[name="one-chiller--switch"]').prop("checked",false);
    //jQuery('.chiller-product.selected').find('[name="chiller--switch"]').prop("checked",false);
    if(jQuery(this).prop("checked") == false){
      jQuery(this).prop("checked",false);
      //jQuery('.bundle_builder_section .chiller-product-two[data-variantid="'+varaintId+'"]').removeClass("selected");
    }
    else{
      jQuery(this).prop("checked",true);
      jQuery('.bundle_builder_section .chiller-product-two[data-variantid="'+varaintId+'"]').addClass("selected");
    }
    // jQuery('.bundle_builder_section .chiller-product-two').removeClass('selected');
    // jQuery('.bundle_builder_section .chiller-product-two[data-variantid="'+varaintId+'"]').addClass("selected");
    selectedProductsData();
    //multipleSteps(3);
  });
  jQuery(document).on("change",".mob-chiller-subscribe-purchase [name='one-chiller--switch']",function(){
    jQuery('.mob-chiller-subscribe-purchase [name="chiller--switch"]').prop("checked",false);
    // jQuery('.chiller-product.selected').find('[name="one-chiller--switch"]').prop("checked",false);
    // jQuery('.chiller-product.selected').find('[name="chiller--switch"]').prop("checked",false);
    var varaintId = jQuery(this).attr("data-vid");
    if(jQuery(this).prop("checked") == false){
      jQuery(this).prop("checked",false);
      //jQuery('.bundle_builder_section .chiller-product-two[data-variantid="'+varaintId+'"]').removeClass("selected");
    }
    else{
      jQuery(this).prop("checked",true);
      jQuery('.bundle_builder_section .chiller-product-two[data-variantid="'+varaintId+'"]').addClass("selected");
    }
    
    // jQuery('.bundle_builder_section .chiller-product-two').removeClass('selected');
    // jQuery('.bundle_builder_section .chiller-product-two[data-variantid="'+varaintId+'"]').addClass("selected");
    selectedProductsData();
    //multipleSteps(3);
  });

  jQuery(document).on("change",".mobile-no-chiller-subscribe-purchase [name='chiller--switch']",function(){
    jQuery('.mobile-no-chiller-subscribe-purchase [name="one-chiller--switch"]').prop("checked",false);
    var varaintId = jQuery(this).attr("data-vid");
    //jQuery('.bundle_builder_section .no-chiller-product').removeClass('selected');
    jQuery('.bundle_builder_section .no-chiller-product[data-variantid="'+varaintId+'"]').addClass("selected");
    selectedProductsData();
    //multipleSteps(3);
  });
  jQuery(document).on("change",".mobile-no-chiller-subscribe-purchase [name='one-chiller--switch']",function(){
    jQuery('.no-chiller-product.selected').find('[name="chiller--switch"]').prop("checked",false);
    var varaintId = jQuery(this).attr("data-vid");
    //jQuery('.bundle_builder_section .no-chiller-product').removeClass('selected');
    jQuery('.no-chiller-maintenance-section .no-chiller-product[data-variantid="'+varaintId+'"]').addClass("selected");
    selectedProductsData();
    //multipleSteps(3);
  });

/************** Mobile device end js ******************/

jQuery(document).on("click",".footer-next-button",function(){
  var getSteps = jQuery('.current_step').val();
  getSteps = (parseInt(getSteps));
  //console.log("getStepsgetSteps",getSteps);
  multipleSteps(getSteps);
  if(getSteps!=1){
    jQuery('.bundle-builder-footer-total').find('.footer-previous-button').show();
  }else if(jQuery('.bundle_navigation_col.selected-steps.active-label[nav-steps="2"]').length==1){
    jQuery('.bundle-builder-footer-total').find('.footer-previous-button').show();
  }else{
    jQuery('.bundle-builder-footer-total').find('.footer-previous-button').hide();
  }
  if(jQuery(window).width()<=767){
    jQuery("html, body").animate({
      scrollTop: 0
    });
  }
});

jQuery(document).on("click",".ba_nothanks,.chiller-button,.no-chiller-button,.no-cooling-button",function(){
  if(jQuery(this).attr("data-step")==2){
    jQuery('#pod_step_2').hide();
    jQuery('.bundle_navigation_col[nav-steps="2"]').removeClass("active-label");
    jQuery('.bundle_navigation_col[nav-steps="3"]').addClass("selected-steps").addClass("active-label");
    jQuery('.bundle_navigation_col .bn_col_box[data-tab="pod_step_3"]').addClass("active");
    var percentageWidth = (100/5);
    percentageWidth = (percentageWidth*3);
    jQuery('.bundle_navigation_section').find('.bn_progress_fill').css("width",percentageWidth+'%');
    jQuery('.pod_maintenance').find('.chiller-maintenance-section').hide();
    jQuery('.pod_maintenance').find('.no-chiller-maintenance-section').show();
    jQuery('.main-product-text-image.active').find('.podcta-selected').hide();
    jQuery('.main-product-text-image.active').find('.podcta-select').show();
    jQuery('.main-product-text-image.active').removeClass("active");
    jQuery('.pod_cooling_option .your-pod-button.selected').removeClass("selected");
    jQuery('.cooling-product-quantity-card.selected').find(".cooling-label").removeClass("active");
    jQuery('.cooling-product-quantity-card.selected').find("[type='radio']").prop("checked",false);
    jQuery('.cooling-product-quantity-card.selected').removeClass("selected");
    jQuery('.no-chiller-product.selected').find("[type='radio']").prop("checked",false);
    jQuery('.no-chiller-product.selected').removeClass("selected");
    jQuery('.chiller-product-two.selected').find('[name="chiller--switch"]').prop("checked",false);
    jQuery('.chiller-product-two.selected').find('[name="one-chiller--switch"]').prop("checked",false);
    jQuery('.chiller-product-three.selected').find('[name="chiller--switch"]').prop("checked",false);
    jQuery('.chiller-product-three.selected').find('[name="one-chiller--switch"]').prop("checked",false);
    jQuery('.main-cooling-product-quantity').find('.cooling-product-quantity-card').removeClass("selected");
    jQuery('#pod_step_3').show();
    jQuery('.current_step').val(3);
    selectedProductsData();
  }else if(jQuery(this).attr("data-step")==3){
    jQuery('.footer-card-close[data-chiller="1"]').trigger("click");
    jQuery('.footer-card-close[data-chiller="2"]').trigger("click");
  }else if(jQuery(this).attr("data-step")==4){
    jQuery('.footer-card-close.remove-accessories').each(function(){
      var variantId = jQuery(this).attr('data-vid');
      bundleBuilderItems = removeByKeyValue(bundleBuilderItems, "variant_id",variantId);
      if(jQuery('.ap_btn_add[data-variantid="'+variantId+'"]').length!=0){
        jQuery('.ap_btn_add[data-variantid="'+variantId+'"]').show();
        jQuery('.ap_btn_add[data-variantid="'+variantId+'"]').parent('div').find('.ap_btn_select').hide();
      }
    });
    reviewOrderHtmlAndcartItemHtml(bundleBuilderItems);
  }
  if(jQuery(this).attr("data-step")!=2){
    setTimeout(function(){
      jQuery('.footer-next-button').trigger("click");
    },100);
  }
});

function removeFirstStepData(){
  //console.log("remove first data");
  jQuery('.bundle-builder-footer').find('.count-bundle-footer').text('(0)');
  var priceReset = Shopify.formatMoney(0);
  jQuery('.bundle-builder-footer').find('.bundle-builder-footer-total').find('.compare_at_price').text(priceReset);
  jQuery('.bundle-builder-footer').find('.bundle-builder-footer-total').find('.price').text(priceReset);
  jQuery('.pod_pickyour_pod .main-product-text-image.active').find('.podcta--primary').removeClass("selected");
  jQuery('.pod_pickyour_pod .main-product-text-image.active').find('.podcta-selected').hide();
  jQuery('.pod_pickyour_pod .main-product-text-image.active').find('.podcta-select').show();
  jQuery('.bundle-builder-footer').find('.new-set a').removeClass('active');
  jQuery('.bundle-builder-footer').find('.new-set .footer-content').hide();
  //jQuery('.bundle-builder-footer').hide();
  jQuery('.pod_pickyour_pod .main-product-text-image').removeClass("active");
}

function removeSecondStepData(){
  console.log("removed");
  jQuery('.pod_maintenance .chiller--switch').find('[name="chiller--switch"]').prop("checked",false);
  jQuery('.pod_maintenance .chiller--switch').find('[name="one-chiller--switch"]').prop("checked",false);
  jQuery('.pod_maintenance .no-chiller-product.selected').removeClass("selected");
  jQuery('[nav-steps="3"]').removeClass("selected-steps"); 
  jQuery('.pod_maintenance').find('.no-chiller-accordion').hide();
  
  jQuery('.pod_maintenance .chiller-product.selected').removeClass("selected");
  jQuery('.pod_cooling_option .cooling-product-quantity-card.selected').find("[type='radio']").prop("checked",false);
  jQuery('.pod_cooling_option .cooling-product-quantity-card.selected').find(".cooling-label").removeClass("active");
  jQuery('.pod_cooling_option .cooling-product-quantity-card.selected').removeClass("selected");
  jQuery('.pod_cooling_option .main-product-text-image.active').find('.podcta-select').show();
  jQuery('.pod_cooling_option .main-product-text-image.active').find('.podcta-selected').hide();
  jQuery('.pod_cooling_option .main-product-text-image.active').removeClass("active");
  var variantId = jQuery('.footer-card-close[data-chiller="1"]').attr('data-vid');
  bundleBuilderItems = removeByKeyValue(bundleBuilderItems, "variant_id",variantId);
  reviewOrderHtmlAndcartItemHtml(bundleBuilderItems);
  var variantId = jQuery('.footer-card-close[data-chiller="2"]').attr('data-vid');
  bundleBuilderItems = removeByKeyValue(bundleBuilderItems, "variant_id",variantId);
  if(jQuery('.footer-content').find('.footer-content-card').length<=2 && jQuery('.footer-content-card').find('.footer-card-close.remove-pod').length==0){
    jQuery('.bundle-builder-footer').find('.count-bundle-footer').text('(0)');
    var priceReset = Shopify.formatMoney(0);
    jQuery('.bundle-builder-footer').find('.bundle-builder-footer-total').find('.compare_at_price').text(priceReset);
    jQuery('.bundle-builder-footer').find('.bundle-builder-footer-total').find('.price').text(priceReset);
    jQuery('.bundle-builder-footer').find('.new-set .footer-content').hide();
    jQuery('.pod_pickyour_pod').find('.podcta--primary.selected').find('.podcta-selected').hide();
    jQuery('.pod_pickyour_pod').find('.podcta--primary.selected').find('.podcta-select').show();
    jQuery('.pod_pickyour_pod').find('.podcta--primary.selected').removeClass('selected');
    jQuery('.pod_cooling_option.pod_steps').find('.your-pod-button.selected').removeClass('selected');
    jQuery('.bundle-builder-footer').find('.new-set a').removeClass('active');
    jQuery('.pod_pickyour_pod').find('.main-product-text-image').removeClass('active');
    navigationpreviousSteps(2);
  }
  reviewOrderHtmlAndcartItemHtml(bundleBuilderItems);
  
}

jQuery(document).on("click",".footer-content-card .footer-card-close,.bundle_review_products .br_product_remove",function(){
  var variantId = jQuery(this).attr('data-vid');
  console.log("variantId",variantId);
  bundleBuilderItems = removeByKeyValue(bundleBuilderItems, "variant_id",variantId);
  if(jQuery('.current_step').val()==2 && jQuery(this).hasClass('remove-pod') && jQuery('.bundle-builder-footer .footer-content-card').length==1){
    removeFirstStepData();
    previousSteps();
  }
  if(jQuery(this).hasClass('remove-cooling')){
    removeSecondStepData();
    previousSteps();
  }
  if(jQuery('.ap_btn_add[data-variantid="'+variantId+'"]').length!=0){
    jQuery('.ap_btn_add[data-variantid="'+variantId+'"]').show();
    jQuery('.ap_btn_add[data-variantid="'+variantId+'"]').parent('div').find('.ap_btn_select').hide();
  }
  if(jQuery(this).attr('data-chiller')!=undefined){
    if(jQuery(this).attr('data-chiller')==1){
      jQuery('.chiller-product.chiller-product-two.selected[data-variantid="'+variantId+'"]').find('[name="chiller--switch"]').prop("checked",false);
      jQuery('.chiller-product.chiller-product-two.selected[data-variantid="'+variantId+'"]').find('[name="one-chiller--switch"]').prop("checked",false);
      jQuery('.chiller-product.chiller-product-two.selected[data-variantid="'+variantId+'"]').removeClass("selected");
      jQuery('.no-chiller-product.selected[data-variantid="'+variantId+'"]').find('[name="one-chiller--switch"]').prop("checked",false);
      jQuery('.no-chiller-product.selected[data-variantid="'+variantId+'"]').find('[name="chiller--switch"]').prop("checked",false);
      jQuery('.no-chiller-product.selected[data-variantid="'+variantId+'"]').removeClass("selected");
    }else if(jQuery(this).attr('data-chiller')==2){
      jQuery('.chiller-product.chiller-product-three.selected[data-variantid="'+variantId+'"]').find('[name="chiller--switch"]').prop("checked",false);
      jQuery('.chiller-product.chiller-product-three.selected[data-variantid="'+variantId+'"]').find('[name="one-chiller--switch"]').prop("checked",false);
      jQuery('.no-chiller-product.selected[data-variantid="'+variantId+'"]').find('[name="one-chiller--switch"]').prop("checked",false);
      jQuery('.no-chiller-product.selected[data-variantid="'+variantId+'"]').find('[name="chiller--switch"]').prop("checked",false);
      jQuery('.no-chiller-product.selected[data-variantid="'+variantId+'"]').removeClass("selected");
      jQuery('.chiller-product.chiller-product-three.selected[data-variantid="'+variantId+'"]').removeClass("selected");
    }
    jQuery('.no-chiller-accordion').hide();
    jQuery('.no-chiller-accordion .no-chiller-set a').removeClass('active');
    jQuery('.no-chiller-accordion .no-chiller-set .no-chiller-content').hide();
  }
  reviewOrderHtmlAndcartItemHtml(bundleBuilderItems);
});

jQuery(document).on("click",".pod_review .qty-count--add",function(){
  let quantityInput = $(this).siblings('.product-qty');
  let currentVal = parseInt(quantityInput.val());
  if (!isNaN(currentVal)) {
    quantityInput.val(currentVal + 1);
  }
  updateReviewSubTotal();
});

jQuery(document).on("click",".pod_review .qty-count--minus",function(){
  let quantityInput = $(this).siblings('.product-qty');
  let currentVal = parseInt(quantityInput.val());
  if (!isNaN(currentVal) && currentVal > 1) { // Prevent going below 1
    quantityInput.val(currentVal - 1);
  }
  updateReviewSubTotal();
});

function updateReviewSubTotal(){
  if(bundleBuilderItems.length>0){
      var totalPrice = 0;
      var totalCPrice = 0;
      var savingPrice = 0;
     jQuery.each(bundleBuilderItems, function( index, value ) {
       var variantIdCart = value.variant_id;
       var quantityGet = jQuery('.pod_review').find('.product-qty[data-vid="'+variantIdCart+'"]').val();
       if(quantityGet=="" || quantityGet==undefined){
         quantityGet=1;
       }
       var price = eval(value.price) * eval(quantityGet);
       var cprice = value.cprice
        
       totalPrice+= parseFloat(price);
       if(cprice!="" && cprice!=undefined){
          var newcprice = eval(value.cprice) * eval(quantityGet);
          totalCPrice+=parseFloat(newcprice);
          var differntPrice = (parseFloat(newcprice)-parseFloat(price));
          savingPrice+=differntPrice;
       }
     });

    if(jQuery('.bundle--switch-extend-first.active').length!=0){
       var getProducts = jQuery('.bundle--switch-extend-first.active').attr('data-pid');
       var extendvariantId = jQuery('.warranty_extend_'+getProducts+' option:selected').val();
       var exPrice = jQuery('.warranty_extend_'+getProducts+' option:selected').attr('data-price1');
       var exCmpPrice = jQuery('.warranty_extend_'+getProducts+' option:selected').attr('data-cprice1');
       console.log("exPrice",exPrice);
       totalPrice+= parseFloat(exPrice);
       totalCPrice+=parseFloat(exCmpPrice);
       var differntPrice1 = (parseFloat(exCmpPrice)-parseFloat(exPrice));
       savingPrice+=differntPrice1;
     }
     if(jQuery('.bundle--switch-extend-second.active').length!=0){
       var getProducts = jQuery('.bundle--switch-extend-second.active').attr('data-pid');
       var extendvariantId = jQuery('.warranty_extend1_'+getProducts+' option:selected').val();
       var exPrice = jQuery('.warranty_extend1_'+getProducts+' option:selected').attr("data-price1");
       console.log("exPrice",exPrice);
       totalPrice+= parseFloat(exPrice);
     }
    if(jQuery('.bundle--switch-extend-third.active').length!=0){
       var extendvariantId = jQuery('[name="pw_switch_chiller_extend"]:checked').attr("data-vid");
       if(extendvariantId!=undefined){
        var exPrice = jQuery('[name="pw_switch_chiller_extend"]:checked').attr("data-price");
         totalPrice+= parseFloat(exPrice);
       }
    }
    if(totalCPrice!=0 && totalCPrice!=""){
      //savingPrice = (totalCPrice-totalPrice);
      savingPrice=Shopify.formatMoney(savingPrice);
      jQuery('.bundle_review_footer').find('.br_saving_price').text(savingPrice);
    }
    totalPrice=Shopify.formatMoney(totalPrice);
    totalCPrice=Shopify.formatMoney(totalCPrice);
    savingPrice = Shopify.formatMoney(savingPrice);

    if(totalCPrice==0 || totalCPrice==""){
      jQuery('.bundle_review_footer').find('.br_saving_price').text(savingPrice);
    }
    
    jQuery('.bundle_review_footer').find('.br_subtotal_sale').text(totalPrice);
    jQuery('.bundle_review_footer').find('.br_subtotal_compare').text(totalCPrice);
    jQuery('.footer-subtotal-price').find('.compare_at_price').text(totalCPrice);
    jQuery('.footer-subtotal-price').find('.price').text(totalPrice);
  }
}

jQuery(document).on("change",'[name="bundle--switch-extend1"]',function(){
  updateReviewSubTotal();
});
jQuery(document).on("change",'[name="bundle--switch-extend"]',function(){
  updateReviewSubTotal();
});
jQuery(document).on("change",'[name="pw_switch_chiller_extend"]',function(){
  updateReviewSubTotal();
});

jQuery(document).on("change",".extend_warranty_product",function(){
  var productId = jQuery(this).attr("data-pid");
  var priceGet = jQuery(this).find('option:selected').attr("data-price");
  var priceCmpGet = jQuery(this).find('option:selected').attr("data-cprice");
  jQuery('.warranty_maincnt_'+productId).find('.pw_sale_price').text(priceGet);
  jQuery('.warranty_maincnt_'+productId).find('.pw_compare_price').text(priceCmpGet);
  updateReviewSubTotal();
});

jQuery(document).on("change",".bundle--switch-extend-first",function(){
  var productId = jQuery(this).attr('data-pid');
  if(jQuery(this).is(":checked")==true){
    jQuery('.warranty_extend_'+productId).removeAttr('disabled');
    jQuery('.warranty_maincnt_'+productId).find('.pw_option_box').show();
    jQuery('.warranty_maincnt_'+productId).parent('div').addClass("show-select-warranty");
  }else{
    jQuery('.warranty_extend_'+productId).attr('disabled',true);
    jQuery('.warranty_maincnt_'+productId).find('.pw_option_box').hide();
    jQuery('.warranty_maincnt_'+productId).parent('div').removeClass("show-select-warranty");
  }
  updateReviewSubTotal();
});

jQuery(document).on("change",".bundle--switch-extend-second",function(){
  var productId = jQuery(this).attr('data-pid');
  if(jQuery(this).is(":checked")==true){
    jQuery('.warranty_extend1_'+productId).removeAttr('disabled');
    jQuery('.warranty_maincnt1_'+productId).find('.pw_option_box').show();
    jQuery('.warranty_maincnt1_'+productId).parent('div').addClass("show-select-warranty");
  }else{
    jQuery('.warranty_extend1_'+productId).attr('disabled',true);
    jQuery('.warranty_maincnt1_'+productId).find('.pw_option_box').hide();
    jQuery('.warranty_maincnt1_'+productId).parent('div').removeClass("show-select-warranty");
  }
  updateReviewSubTotal();
});

/*jQuery(document).on("change",".extend_warranty_product",function(){
  
});*/

jQuery(document).on("change",".extend_warranty_product_1",function(){
  var productId = jQuery(this).attr("data-pid");
  var priceGet = jQuery(this).find('option:selected').attr("data-price");
  jQuery('.warranty_maincnt_'+productId).find('.pw_sale_price').text(priceGet);
});

jQuery(document).on("click",".bundle_review_footer .br_footer_checkout,.footer-checkout-button",function(){
  jQuery('.footer-next-button').addClass("footer-checkout-button");
  jQuery('.footer-next-button').find('span').text("Secure Checkout");
  if(bundleBuilderItems.length>0){
     var itemData = [];
     jQuery('.pod-loading').show();
     jQuery.each(bundleBuilderItems, function( index, value ) {
       var variantIdCart = value.variant_id;
       var quantityGet = jQuery('.pod_review').find('.product-qty[data-vid="'+variantIdCart+'"]').val();
       if(quantityGet=="" || quantityGet==undefined){
         quantityGet=1;
       }
       if(value.selling_id!="" && value.selling_id!=undefined){
         var sellingId = value.selling_id;
         itemData.push({
           id:variantIdCart,
           quantity:quantityGet,
           selling_plan:sellingId
         });
       }else{
         itemData.push({
           id:variantIdCart,
           quantity:quantityGet
         });
       }
     });
     if(jQuery('.bundle--switch-extend-first.active').length!=0){
       var getProducts = jQuery('.bundle--switch-extend-first.active').attr('data-pid');
       var extendvariantId = jQuery('.warranty_extend_'+getProducts+' option:selected').val();
       itemData.push({
         id:extendvariantId,
         quantity:1
       });
     }
     if(jQuery('.bundle--switch-extend-second.active').length!=0){
       var getProducts = jQuery('.bundle--switch-extend-second.active').attr('data-pid');
       var extendvariantId = jQuery('.warranty_extend1_'+getProducts+' option:selected').val();
       itemData.push({
         id:extendvariantId,
         quantity:1
       });
     }
     if(jQuery('.bundle--switch-extend-third.active').length!=0){
       var extendvariantId = jQuery('[name="pw_switch_chiller_extend"]:checked').attr("data-vid");
       if(extendvariantId!=undefined){
         itemData.push({
           id:extendvariantId,
           quantity:1
         });
       }
     }
     if(itemData.length!=0){
       var clInterval = setInterval(function(){
         closeDrawer(clInterval);
       });
       jQuery.ajax({
        url: '/cart/add.js',
        dataType: 'json',
        cache: false,
        type: 'post',
        data: {items:itemData},
        success(response) {
          var cInterval = setInterval(function(){
            closeDrawer(cInterval);
          });
          jQuery('.pod-loading').hide(); 
          window.location.href="/checkout";
        } 
      });
    }
  }
});
function closeDrawer(cInterval){
  if(jQuery('body').hasClass('upcartPopupShow')){
   jQuery('body').removeClass('upcartPopupShow');
   jQuery('#UpcartPopup').removeClass('upcartPopupShow');
   jQuery('.upcart-backdrop').removeClass("styles_active__7AzVD");
   jQuery('#CartPopup').removeClass("styles_active__7AzVD");
   jQuery('#CartPopup').attr("data-scrollable",false);
   clearInterval(cInterval);
 }
}
function removeByKeyValue(array, key, value) {
    return array.filter(function(element) {
        return element[key] !== value;
    });
}

jQuery(document).on("click",".bundle_navigation_col",function(){
  var steps = jQuery(this).attr('nav-steps');
  if(jQuery(this).hasClass('selected-steps')==false){
    if(steps==3){
      if(jQuery('.pod_pickyour_pod .main-product-text-image.active').length!=0){
        steps=(steps-1);
        multipleSteps(steps);
      }
    }else if(steps==4){
       if((jQuery('.pod_pickyour_pod .main-product-text-image.active').length!=0)){
          steps=(steps-1);
          jQuery('.bundle_navigation_col [data-tab="pod_step_'+steps+'"]').addClass("active");
          multipleSteps(steps);
       }
    }else if(steps==5){
      if((jQuery('.pod_pickyour_pod .main-product-text-image.active').length!=0)){
        steps=(steps-1);
        multipleSteps(steps);
      }
    }else{
      steps=(steps-1);
      multipleSteps(steps);
    }
  }else{
    navigationpreviousSteps(steps);
  }
});

function multipleSteps(steps,flag=''){
  jQuery('.footer-next-button').removeClass("footer-checkout-button");
  jQuery('.footer-next-button').find('span').text("Next");
  var percentageWidth = (100/5);
  var flagprocess=0;
  jQuery('.bundle-builder-footer').show();
  if(steps==1){
    if(jQuery('.pod_pickyour_pod .main-product-text-image.active').length!=0){
      jQuery('.bundle-builder-footer').show();
      jQuery('#pod_step_1').hide();
      jQuery('#pod_step_2').show();
      flagprocess=1;
      //$(".bundle_error_message").hide();
      //$("body").removeClass("bundle_error_message_active");
      jQuery('.bundle-builder-footer .footer-next-button').removeClass('first_select_product');
    }else{
      
      jQuery('.bundle-builder-footer .footer-next-button').addClass('first_select_product');
      //$(".bundle_error_message").show();
      //$("body").addClass("bundle_error_message_active");
    }
    //jQuery('.bundle-builder-footer-total').find('.footer-previous-button').show();
  }else if(steps==2){
    //if(jQuery('.pod_cooling_option .cooling-product-quantity-card.selected').length!=0 || jQuery('.pod_cooling_option .main-product-text-image.active').length!=0){
      if(jQuery('.main-cooling-product-quantity').find('.cooling-product-quantity-card.selected').length!=0){
        jQuery('.pod_maintenance').find('.chiller-maintenance-section').hide();
        jQuery('.pod_maintenance').find('.no-chiller-maintenance-section').show();
      }else if(jQuery('.pod_cooling_option .cooling-product-quantity-card.selected').length==0 && jQuery('.pod_cooling_option .main-product-text-image.active').length==0){
        jQuery('.pod_maintenance').find('.chiller-maintenance-section').hide();
        jQuery('.pod_maintenance').find('.no-chiller-maintenance-section').show();
      }else{
        jQuery('.pod_maintenance').find('.chiller-maintenance-section').show();
        jQuery('.pod_maintenance').find('.no-chiller-maintenance-section').hide();
      }
    //}
    jQuery('.bundle_navigation_col [data-tab="pod_step_2"]').addClass('active');
    jQuery('#pod_step_1').hide();
    jQuery('#pod_step_2').hide();
    jQuery('#pod_step_3').show();
    flagprocess=1;
    jQuery('.bundle-builder-footer-total').find('.footer-previous-button').show();
  }else if(steps==3){
    jQuery('#pod_step_2').hide();
    jQuery('#pod_step_3').hide();
    jQuery('#pod_step_4').show();
    jQuery('.bundle-builder-footer').show();
    flagprocess=1;
    jQuery('.bundle-builder-footer-total').find('.footer-previous-button').show();
  }else if(steps==4){
    jQuery('#pod_step_4').hide();
    jQuery('#pod_step_5').show();
    jQuery('.footer-next-button').addClass("footer-checkout-button");
    jQuery('.footer-next-button').find('span').text("Secure Checkout");
    jQuery('.bundle-builder-footer').hide();
    flagprocess=1;
    jQuery('.bundle-builder-footer-total').find('.footer-previous-button').show();
  }
  jQuery('html,body').animate({
    scrollTop:jQuery('.bundle-navigation-section').offset().top
  },200);
  if(flagprocess==1){
    steps = (steps+1);
    jQuery('.bundle_navigation_section').find('[data-tab="pod_step_'+steps+'"]').addClass("active");
    jQuery('.bundle_navigation_col').removeClass("active-label");
    for(var t=1;t<=steps;t++){
      jQuery('[data-tab="pod_step_'+t+'"]').parent().addClass("selected-steps");  
    }
    jQuery('[data-tab="pod_step_'+steps+'"]').parent().addClass("active-label");
    percentageWidth = (percentageWidth*steps);
    
    jQuery('.bundle_navigation_section').find('.bn_progress_fill').css("width",percentageWidth+'%');
    jQuery('.current_step').val(steps);
  }
}


function selectedProductsData(){
  bundleBuilderItems = [];
  //first steps selected variant push data start here
  if(jQuery('.pod_pickyour_pod .podcta--primary.selected').length!=0){
    var podObject = jQuery('.pod_pickyour_pod .podcta--primary.selected').parent('div');
    var varaintId = podObject.attr("data-variantid");
    var productId = podObject.attr("data-pid");
    var price = podObject.attr("data-price");
    var cprice = podObject.attr("data-cprice");
    var variantTitle = podObject.attr("data-vtitle");
    var podStr = 'long pod';
    var type = 1;
    var lowerTitle = variantTitle.toLowerCase();
    if (lowerTitle.includes(podStr)) {
      type=2;
    }
    bundleBuilderItems.push({
      variant_id:varaintId,
      variant_title:variantTitle,
      product_id:productId,
      price:price,
      cprice:cprice,
      pod_product:1,
      type_product:type,
      image:podObject.attr("data-image"),
      title:podObject.attr("data-title")
    });
  }
  //first steps selected variant push data end here
  
  //second steps selected variant push data start here
  if(jQuery('.pod_cooling_option .cooling-product-quantity-card.selected').length!=0){
    var podObject = jQuery('.pod_cooling_option .cooling-product-quantity-card.selected');
    var varaintId = podObject.attr("data-variantid");
    var productId = podObject.attr("data-pid");
    var price = podObject.attr("data-price");
    var cprice = podObject.attr("data-cprice"); 
    var variantTitle = podObject.attr("data-vtitle");
    if(variantTitle==undefined){
      variantTitle = jQuery('.main-cooling-product-text').find('.cooling-product-text h2').text();
    }
    bundleBuilderItems.push({
      variant_id:varaintId,
      variant_title:podObject.attr("data-title"),
      product_id:productId,
      price:price,
      cprice:cprice,
      cooling_type:1,
      image:podObject.attr("data-image"),
      title:variantTitle
    });
   }
  else if(jQuery('.cooling-products .your-pod-button.selected').length!=0){
      var podObject = jQuery('.cooling-products .your-pod-button.selected');
      var varaintId = podObject.attr("data-variantid");
      var productId = podObject.attr("data-pid");
      var price = podObject.attr("data-price");
      var cprice = podObject.attr("data-cprice");
      var variantTitle = podObject.attr("data-vtitle");
      var chillerStr = 'pro chiller';
      var type = 1;
      var lowerTitle = podObject.attr("data-title").toLowerCase();
      if (lowerTitle.includes(chillerStr)) {
        type=2;
      }
      bundleBuilderItems.push({
        variant_id:varaintId,
        variant_title:variantTitle,
        product_id:productId,
        price:price,
        cprice:cprice,
        cool_product:1,
        cooling_type:1,
        chillar_type:type,
        image:podObject.attr("data-image"),
        title:podObject.attr("data-title")
      });
   }
  //second steps selected variant push data end here

  //third steps selected variant push data start here
  if(jQuery('.main-chiller-product .chiller-product-two.selected').length!=0){
    var podObject = jQuery('.main-chiller-product .chiller-product-two.selected');
    var varaintId = podObject.attr("data-variantid");
    var productId = podObject.attr("data-pid");
    var price = podObject.attr("data-price");
    var cprice = podObject.attr("data-cprice");
    var variantTitle = podObject.attr("data-vtitle");
    var sellingId = '';
    if(podObject.find('[name="chiller--switch"]').is(":checked")){
      sellingId = podObject.find('[name="chiller--switch"]').attr("data-selling-id");
      price = podObject.find('[name="chiller--switch"]').attr("data-price");
      cprice = podObject.find('[name="chiller--switch"]').attr("data-cprice");
      bundleBuilderItems.push({
        variant_id:varaintId,
        variant_title:variantTitle,
        product_id:productId,
        price:price,
        cprice:cprice,
        selling_id:sellingId,
        chiller:1,
        image:podObject.attr("data-image"),
        title:podObject.attr("data-title")
      });
      podObject.find('.no-chiller-accordion').show();
      podObject.find('.no-chiller-accordion .no-chiller-set a').addClass('active');
      podObject.find('.no-chiller-accordion .no-chiller-set .no-chiller-content').show();
    }
    else if(podObject.find('[name="one-chiller--switch"]').is(":checked")){
      sellingId = podObject.find('[name="one-chiller--switch"]').attr("data-selling-id");
      price = podObject.find('[name="one-chiller--switch"]').attr("data-price");
      cprice = podObject.find('[name="one-chiller--switch"]').attr("data-cprice");
      bundleBuilderItems.push({
        variant_id:varaintId,
        variant_title:variantTitle,
        product_id:productId,
        price:price,
        cprice:cprice,
        selling_id:sellingId,
        chiller:1,
        image:podObject.attr("data-image"),
        title:podObject.attr("data-title")
      });
      podObject.find('.no-chiller-accordion').hide();
      podObject.find('.no-chiller-accordion .no-chiller-set a').removeClass('active');
      podObject.find('.no-chiller-accordion .no-chiller-set .no-chiller-content').hide();
    }
    else{
      jQuery('.pod_maintenance .no-chiller-product.chiller-product-two').removeClass("selected");
      jQuery('.main-chiller-product .chiller-product.chiller-product-two').removeClass("selected");
      podObject.find('.no-chiller-accordion').hide();
      podObject.find('.no-chiller-accordion .no-chiller-set a').removeClass('active');
      podObject.find('.no-chiller-accordion .no-chiller-set .no-chiller-content').hide();
    }
  }
  if(jQuery('.main-chiller-product .chiller-product-three.selected').length!=0){
    var podObject = jQuery('.main-chiller-product .chiller-product-three.selected');
    var varaintId = podObject.attr("data-variantid");
    var productId = podObject.attr("data-pid");
    var price = podObject.attr("data-price");
    var cprice = podObject.attr("data-cprice");
    var variantTitle = podObject.attr("data-vtitle");
    var sellingId = '';
    if(podObject.find('[name="chiller--switch"]').is(":checked")){
      sellingId = podObject.find('[name="chiller--switch"]').attr("data-selling-id");
      price = podObject.find('[name="chiller--switch"]').attr("data-price");
      cprice = podObject.find('[name="chiller--switch"]').attr("data-cprice");
      bundleBuilderItems.push({
        variant_id:varaintId,
        variant_title:variantTitle,
        product_id:productId,
        price:price,
        cprice:cprice,
        selling_id:sellingId,
        chiller:2,
        image:podObject.attr("data-image"),
        title:podObject.attr("data-title")
      });
      podObject.find('.no-chiller-accordion').show();
      podObject.find('.no-chiller-accordion .no-chiller-set a').addClass('active');
      podObject.find('.no-chiller-accordion .no-chiller-set .no-chiller-content').show();
    }
    else if(podObject.find('[name="one-chiller--switch"]').is(":checked")){
      sellingId = podObject.find('[name="one-chiller--switch"]').attr("data-selling-id");
      price = podObject.find('[name="one-chiller--switch"]').attr("data-price");
      cprice = podObject.find('[name="one-chiller--switch"]').attr("data-cprice");
      bundleBuilderItems.push({
        variant_id:varaintId,
        variant_title:variantTitle,
        product_id:productId,
        price:price,
        cprice:cprice,
        selling_id:sellingId,
        chiller:2,
        image:podObject.attr("data-image"),
        title:podObject.attr("data-title")
      });
      podObject.find('.no-chiller-accordion').hide();
      podObject.find('.no-chiller-accordion .no-chiller-set a').removeClass('active');
      podObject.find('.no-chiller-accordion .no-chiller-set .no-chiller-content').hide();
    }
    else{
      jQuery('.pod_maintenance .no-chiller-product.chiller-product-three').removeClass("selected");
      jQuery('.main-chiller-product .chiller-product.chiller-product-three').removeClass("selected");
      podObject.find('.no-chiller-accordion').hide();
      podObject.find('.no-chiller-accordion .no-chiller-set a').removeClass('active');
      podObject.find('.no-chiller-accordion .no-chiller-set .no-chiller-content').hide();
    }
  }
  
  if(jQuery('.pod_maintenance .no-chiller-product.selected').length!=0){
      var podObject = jQuery('.pod_maintenance .no-chiller-product.selected');
      var varaintId = podObject.attr("data-variantid");
      var productId = podObject.attr("data-pid");
      var price = podObject.attr("data-price");
      var cprice = podObject.attr("data-cprice");
      var variantTitle = podObject.attr("data-vtitle");
      var sellingId = '';
      if(podObject.find('[name="chiller--switch"]').is(":checked")){
        sellingId = podObject.find('[name="chiller--switch"]').attr("data-selling-id");
        price = podObject.find('[name="chiller--switch"]').attr("data-price");
        cprice = podObject.find('[name="chiller--switch"]').attr("data-cprice");
        bundleBuilderItems.push({
          variant_id:varaintId,
          variant_title:variantTitle,
          product_id:productId,
          price:price,
          cprice:cprice,
          selling_id:sellingId,
          chiller:1,
          image:podObject.attr("data-image"),
          title:podObject.attr("data-title")
        });
        podObject.find('.no-chiller-accordion').show();
        podObject.find('.no-chiller-accordion .no-chiller-set a').addClass('active');
        podObject.find('.no-chiller-accordion .no-chiller-set .no-chiller-content').show();
      }
      else if(podObject.find('[name="one-chiller--switch"]').is(":checked")){
        sellingId = podObject.find('[name="one-chiller--switch"]').attr("data-selling-id");
        price = podObject.find('[name="one-chiller--switch"]').attr("data-price");
        cprice = podObject.find('[name="one-chiller--switch"]').attr("data-cprice");
        bundleBuilderItems.push({
          variant_id:varaintId,
          variant_title:variantTitle,
          product_id:productId,
          price:price,
          cprice:cprice,
          selling_id:sellingId,
          chiller:2,
          image:podObject.attr("data-image"),
          title:podObject.attr("data-title")
        });
        podObject.find('.no-chiller-accordion').hide();
        podObject.find('.no-chiller-accordion .no-chiller-set a').removeClass('active');
        podObject.find('.no-chiller-accordion .no-chiller-set .no-chiller-content').hide();
      }
      else{
        jQuery('.pod_maintenance .no-chiller-product').removeClass("selected");
        jQuery('.main-chiller-product .chiller-product').removeClass("selected");
        podObject.find('.no-chiller-accordion').hide();
        podObject.find('.no-chiller-accordion .no-chiller-set a').removeClass('active');
        podObject.find('.no-chiller-accordion .no-chiller-set .no-chiller-content').hide();
      }
   }
  else{
    //jQuery('.pod_maintenance .no-chiller-product').removeClass("active-selected");
    //jQuery('.main-chiller-product .chiller-product').removeClass("active-selected");
  }
  //third steps selected variant push data end here

  //fourth steps selected variant push data start here
  if(jQuery('.bundle_accessories_grid .accessori_product_col.selected').length!=0){
    jQuery('.bundle_accessories_grid .accessori_product_col.selected').each(function(){
      var podObject = jQuery(this);
      var varaintId = podObject.attr("data-variantid");
      var productId = podObject.attr("data-pid");
      var price = podObject.attr("data-price");
      var cprice = podObject.attr("data-cprice");
      var variantTitle = podObject.attr("data-vtitle");
      bundleBuilderItems.push({
        variant_id:varaintId,
        variant_title:variantTitle,
        product_id:productId,
        price:price,
        cprice:cprice,
        accessories:1,
        image:podObject.attr("data-image"),
        title:podObject.attr("data-title")
      });
    });
   }
  //fourth steps selected variant push data end here
  console.log("log data",bundleBuilderItems);
  reviewOrderHtmlAndcartItemHtml(bundleBuilderItems);
}

function reviewOrderHtmlAndcartItemHtml(bundleBuilderItems){
  var reviewOrderStr='';
  var cartItemsStr = '';
  jQuery('.bundle_review_products').html('');
  jQuery('.bundle-builder-footer').find('.footer-new-content').html("");
  if(bundleBuilderItems.length>0){
    var totalPrice = 0;
    var totalCPrice = 0;
    var savingPrice = 0;
    for(var f=0;f<bundleBuilderItems.length;f++){
      var image=bundleBuilderItems[f].image;
      var pTitle=bundleBuilderItems[f].title;
      var price=bundleBuilderItems[f].price;
      var cprice=bundleBuilderItems[f].cprice;
      var variantId = bundleBuilderItems[f].variant_id;
      var variantTitle = bundleBuilderItems[f].variant_title;
      var productId = bundleBuilderItems[f].product_id;
      totalPrice+=parseFloat(price);
      if(cprice!="" && cprice!=undefined){
        totalCPrice+=parseFloat(cprice);
        var differntPrice = (parseFloat(cprice)-parseFloat(price));
        savingPrice+=differntPrice;
      }
      
      var comparePrice = bundleBuilderItems[f].cprice;
      cprice=Shopify.formatMoney(cprice);
      price=Shopify.formatMoney(price);
      reviewOrderStr+='<div class="bundle_review_col"><div class="bundle_review_product"><div class="br_product_box">';
      reviewOrderStr+='<div class="br_product_img"><img src="'+image+'"></div>';
      reviewOrderStr+='<div class="br_product_content">';
      reviewOrderStr+='<div class="br_content_titlebox">';
      reviewOrderStr+='<div class="br_product_titlecontent"><h6>'+pTitle+'</h6>';
      if(variantTitle!=undefined && variantTitle!='Default Title'){
        reviewOrderStr+='<p><b>Version:</b> '+variantTitle+'</p>';
      }
      reviewOrderStr+='</div>';
      reviewOrderStr+='<div class="br_product_remove" data-vid="'+variantId+'" data-pid="'+productId+'">';
      reviewOrderStr+='<svg xmlns="http://www.w3.org/2000/svg" width="22" height="23" viewBox="0 0 22 23" fill="none"><g opacity="0.5">';
      reviewOrderStr+='<path d="M18.5625 4.625H15.125V3.9375C15.125 3.39049 14.9077 2.86589 14.5209 2.47909C14.1341 2.0923 13.6095 1.875 13.0625 1.875H8.9375C8.39049 1.875 7.86589 2.0923 7.47909 2.47909C7.0923 2.86589 6.875 3.39049 6.875 3.9375V4.625H3.4375C3.25516 4.625 3.0803 4.69743 2.95136 4.82636C2.82243 4.9553 2.75 5.13016 2.75 5.3125C2.75 5.49484 2.82243 5.6697 2.95136 5.79864C3.0803 5.92757 3.25516 6 3.4375 6H4.125V18.375C4.125 18.7397 4.26987 19.0894 4.52773 19.3473C4.78559 19.6051 5.13533 19.75 5.5 19.75H16.5C16.8647 19.75 17.2144 19.6051 17.4723 19.3473C17.7301 19.0894 17.875 18.7397 17.875 18.375V6H18.5625C18.7448 6 18.9197 5.92757 19.0486 5.79864C19.1776 5.6697 19.25 5.49484 19.25 5.3125C19.25 5.13016 19.1776 4.9553 19.0486 4.82636C18.9197 4.69743 18.7448 4.625 18.5625 4.625ZM8.25 3.9375C8.25 3.75516 8.32243 3.5803 8.45136 3.45136C8.5803 3.32243 8.75516 3.25 8.9375 3.25H13.0625C13.2448 3.25 13.4197 3.32243 13.5486 3.45136C13.6776 3.5803 13.75 3.75516 13.75 3.9375V4.625H8.25V3.9375ZM16.5 18.375H5.5V6H16.5V18.375ZM9.625 9.4375V14.9375C9.625 15.1198 9.55257 15.2947 9.42364 15.4236C9.2947 15.5526 9.11984 15.625 8.9375 15.625C8.75516 15.625 8.5803 15.5526 8.45136 15.4236C8.32243 15.2947 8.25 15.1198 8.25 14.9375V9.4375C8.25 9.25516 8.32243 9.0803 8.45136 8.95136C8.5803 8.82243 8.75516 8.75 8.9375 8.75C9.11984 8.75 9.2947 8.82243 9.42364 8.95136C9.55257 9.0803 9.625 9.25516 9.625 9.4375ZM13.75 9.4375V14.9375C13.75 15.1198 13.6776 15.2947 13.5486 15.4236C13.4197 15.5526 13.2448 15.625 13.0625 15.625C12.8802 15.625 12.7053 15.5526 12.5764 15.4236C12.4474 15.2947 12.375 15.1198 12.375 14.9375V9.4375C12.375 9.25516 12.4474 9.0803 12.5764 8.95136C12.7053 8.82243 12.8802 8.75 13.0625 8.75C13.2448 8.75 13.4197 8.82243 13.5486 8.95136C13.6776 9.0803 13.75 9.25516 13.75 9.4375Z" fill="#101010"/></path>';
      reviewOrderStr+='</g></svg></div></div>';
      reviewOrderStr+='<div class="br_content_quantity">';
      reviewOrderStr+='<div class="br_product_pricebox">';
      if(comparePrice!="" && comparePrice!=undefined){
        reviewOrderStr+='<span class="br_compare_price">'+cprice+'</span>';
      }
      reviewOrderStr+='<span class="br_sale_price">'+price+'</span>';
      //reviewOrderStr+='<span class="br_free_label">FREE</span>';
      reviewOrderStr+='</div>';
      reviewOrderStr+='<div class="br_product_quantity"><div class="qty-input">';
      reviewOrderStr+='<button class="qty-count qty-count--minus" data-action="minus" type="button"><svg xmlns="http://www.w3.org/2000/svg" width="9" height="2" viewBox="0 0 9 2" fill="none">';
      reviewOrderStr+='<path d="M8.94434 1L0.055447 1" stroke="#101010" stroke-width="1.48148"/></path></svg></button>';
      reviewOrderStr+='<input class="product-qty" type="number" name="product-qty" min="0" max="10" value="1" data-vid="'+variantId+'">';
      reviewOrderStr+='<button class="qty-count qty-count--add" data-action="add" type="button"><svg xmlns="http://www.w3.org/2000/svg" width="9" height="10" viewBox="0 0 9 10" fill="none">';
      reviewOrderStr+='<path fill-rule="evenodd" clip-rule="evenodd" d="M3.75937 5.74085V9.44455H5.24085V5.74085H8.94455V4.25937H5.24085V0.555664H3.75937V4.25937H0.0556641L0.0556641 5.74085H3.75937Z" fill="#101010"/></path></svg>';
      reviewOrderStr+='</button></div></div></div></div></div>';
      var pod_product = "";
      if(bundleBuilderItems[f].pod_product!=undefined){
        if(bundleBuilderItems[f].type_product == 1){
          if(jQuery('.extend_product_data').find('.extend_product_first').length!=0){
            var getWarrantyHtml = jQuery('.extend_product_first').html();
            let $html1 = $(getWarrantyHtml);
            var productIds =  $html1.find('.bundle--switch-extend-first').attr('data-pid');
            $html1.find('.bundle--switch-extend-first').attr('id',"pw_switch_warranty_extend");
            $html1.find('.bundle--switch-extend-first').attr('name',"pw_switch_warranty_extend");
            $html1.find('.bundle--switch-extend-first').parent('label').attr('for',"pw_switch_warranty_extend");
            $html1.find('.product_warranty_content').addClass("warranty_maincnt_"+productIds);
            $html1.find('.extend_warranty_product').addClass("warranty_extend_"+productIds);
            $html1.find('.product_warranty_content').parent().addClass('pwb-select');
            $html1.find('.extend_warranty_product').attr("data-pid",productIds);
            getWarrantyHtml = $html1.prop('outerHTML');
            reviewOrderStr+=getWarrantyHtml;
          }
        }
        else{
          if(jQuery('.extend_product_data').find('.extend_product_second').length!=0){
            var getWarrantyHtml = jQuery('.extend_product_second').html();
            let $html = $(getWarrantyHtml);
            $html.find('.bundle--switch-extend-second').attr('id',"pw_switch_warranty_extend1");
            var productIds =  $html.find('.bundle--switch-extend-second').attr('data-pid');
            $html.find('.bundle--switch-extend-second').attr('name',"pw_switch_warranty_extend1");
            $html.find('.bundle--switch-extend-second').parent('label').attr('for',"pw_switch_warranty_extend1");
            $html.find('.product_warranty_content').addClass("warranty_maincnt_"+productIds);
            $html.find('.extend_warranty_product_1').addClass("warranty_extend1_"+productIds);
            $html.find('.extend_warranty_product_1').attr("data-pid",productIds);
            $html.find('.product_warranty_content').parent().addClass('pwb-select');
            // Convert it back to an HTML string if needed
            getWarrantyHtml = $html.prop('outerHTML');
            reviewOrderStr+=getWarrantyHtml;
          }
        }
        pod_product='remove-pod';
      }
      var coolingproduct = "";
      if(bundleBuilderItems[f].cooling_type!=undefined){
        coolingproduct='remove-cooling';
      }
      if(bundleBuilderItems[f].cool_product!=undefined){
        if(jQuery('.extend_product_data').find('.extend_product_third').length!=0){
          var getWarrantyHtml = jQuery('.extend_product_third').html();
          let $html = $(getWarrantyHtml);
          $html.find('#pw_switch_chiller_extend1').parent().attr('for',"pw_switch_warranty_chiller_extend1");
          $html.find('#pw_switch_chiller_extend2').parent().attr('for',"pw_switch_warranty_chiller_extend2");
          $html.find('#pw_switch_chiller_extend1').attr('id',"pw_switch_warranty_chiller_extend1");
          $html.find('#pw_switch_chiller_extend2').attr('id',"pw_switch_warranty_chiller_extend2");
          if(bundleBuilderItems[f].chillar_type == 1){
            $html.find('.pw_switch_box').eq(0).attr('style',"display:block");
            $html.find('.pw_switch_box').eq(1).attr('style',"display:none");
          }else if(bundleBuilderItems[f].chillar_type == 2){
            $html.find('.pw_switch_box').eq(1).attr('style',"display:block");
            $html.find('.pw_switch_box').eq(0).attr('style',"display:none");
          }
          // Convert it back to an HTML string if needed
          getWarrantyHtml = $html.prop('outerHTML');
          reviewOrderStr+=getWarrantyHtml;
        }
        
      }
      var selling_flag='';
      if(bundleBuilderItems[f].selling_id!=undefined){
        selling_flag=1;
      }
      var chiller_product="";
      if(bundleBuilderItems[f].chiller!=undefined){
        chiller_product='data-chiller="1"';
        if(bundleBuilderItems[f].chiller==2){
          chiller_product='data-chiller="2"';
        }
      }
      var accessories_product = "";
      if(bundleBuilderItems[f].accessories!=undefined){
        accessories_product='remove-accessories';
      }
      reviewOrderStr+='</div></div>';
      cartItemsStr+='<div class="footer-content-card"><div class="footer-content-product-image">';
      cartItemsStr+='<img src="'+image+'">';
      cartItemsStr+='<div class="footer-card-close '+accessories_product+' '+pod_product+' '+coolingproduct+'" '+chiller_product+' data-selling="'+selling_flag+'" data-vid="'+variantId+'" data-pid="'+productId+'"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">';
      cartItemsStr+='<rect width="24" height="24" rx="12" fill="#F7F7F7"></rect><path d="M17 7L7 17M7 7L17 17" stroke="#101010" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>';
      cartItemsStr+='</svg></div></div>';
      cartItemsStr+='<div class="footer-content-product-details"><span class="title">'+pTitle+'</span>';
      cartItemsStr+='<div class="footer-price-free">';
      if(comparePrice!="" && comparePrice!=undefined){
        cartItemsStr+='<span class="footer-compare_at_price">'+cprice+'</span>';
      }
      cartItemsStr+='<span class="footer_price">'+price+'</span>';
      //cartItemsStr+='<span class="footer-free">FREE</span>';
      cartItemsStr+='</div></div></div>';
    }
    totalPrice=Shopify.formatMoney(totalPrice);
    totalCPrice=Shopify.formatMoney(totalCPrice);
    savingPrice = Shopify.formatMoney(savingPrice);
    jQuery('.bundle-builder-footer').find('.footer-new-content').html(cartItemsStr);
    jQuery('.bundle_review_footer').find('.br_saving_price').text(savingPrice);
    jQuery('.bundle_review_footer').find('.br_subtotal_sale').text(totalPrice);
    jQuery('.bundle_review_footer').find('.br_subtotal_compare').text(totalCPrice);
    jQuery('.footer-subtotal-price').find('.compare_at_price').text(totalCPrice);
    jQuery('.footer-subtotal-price').find('.price').text(totalPrice);
    jQuery('.bundle-builder-footer').find('.count-bundle-footer').text('('+bundleBuilderItems.length+')');
    jQuery('.bundle_review_products').html(reviewOrderStr);
  }
}

jQuery(document).on("click",".bundle-builder-footer .footer-previous-button",function(){
  previousSteps();
});

function navigationpreviousSteps(steps){
  var percentageWidth = (100/5);
  var coolingCheck = 0;
  /*if(steps==3){
    coolingCheck = jQuery('.pod_cooling_option .main-product-text-image.selected').length;
    if(coolingCheck==0){
      coolingCheck = jQuery('.pod_cooling_option .cooling-product-quantity-card.selected').length;
    }
  }
  if(steps==3 && coolingCheck==0){
    
  }else{*/
    jQuery('.current_step').val(steps);
    jQuery('.pod_steps').hide();
    jQuery('.footer-next-button').removeClass("footer-checkout-button");
    jQuery('.footer-next-button').find('span').text("Next");
    jQuery('#pod_step_'+steps).show();
    jQuery('.bundle_navigation_section').find(".bn_col_box").removeClass("active");
    jQuery('.bundle_navigation_col').removeClass("active-label").removeClass("selected-steps");
    jQuery('[data-tab="pod_step_'+steps+'"]').parent().addClass("active-label");
    for(var g=1;g<=steps;g++){
      jQuery('.bundle_navigation_section').find('[data-tab="pod_step_'+g+'"]').addClass("active");
      jQuery('.bundle_navigation_section').find('[data-tab="pod_step_'+g+'"]').parent().addClass("selected-steps");
    }
    percentageWidth = (percentageWidth*steps);
    jQuery('.bundle_navigation_section').find('.bn_progress_fill').css("width",percentageWidth+'%');
  //}
  if(steps<5){
    jQuery('.bundle-builder-footer').show();
  }else{
    jQuery('.bundle-builder-footer').hide();
  }
  if(steps==1){
    jQuery('.bundle-builder-footer-total').find('.footer-previous-button').hide();
  }else{
    jQuery('.bundle-builder-footer-total').find('.footer-previous-button').show();
  }
}

function previousSteps(){
  var stepsGet = jQuery('.current_step').val();
  var percentageWidth = (100/5);
  stepsGet = (stepsGet-1);
  jQuery('.current_step').val(stepsGet);
  jQuery('.pod_steps').hide();
  jQuery('.footer-next-button').removeClass("footer-checkout-button");
  jQuery('.footer-next-button').find('span').text("Next");
  jQuery('#pod_step_'+stepsGet).show();
  jQuery('.bundle_navigation_section').find(".bn_col_box").removeClass("active");
  jQuery('.bundle_navigation_col').removeClass("active-label");
  jQuery('[data-tab="pod_step_'+stepsGet+'"]').parent().addClass("active-label");
  for(var g=1;g<=stepsGet;g++){
    jQuery('.bundle_navigation_section').find('[data-tab="pod_step_'+g+'"]').addClass("active");
  }
  if(stepsGet<5){
    jQuery('.bundle-builder-footer').show();
  }else{
    jQuery('.bundle-builder-footer').hide();
  }
  if(stepsGet==1){
    jQuery('.bundle-builder-footer-total').find('.footer-previous-button').hide();
  }else{
    jQuery('.bundle-builder-footer-total').find('.footer-previous-button').show();
  }
  percentageWidth = (percentageWidth*stepsGet);
  jQuery('.bundle_navigation_section').find('.bn_progress_fill').css("width",percentageWidth+'%');
}

function removeVariantId(arr, variantId) {
    let found = false;
    return arr.filter(function(item) {
      if (!found && parseInt(item.variant_id) === parseInt(variantId)) {
        found = true;
        return false; // Skip this item
      }
      return true; // Keep this item
    });
}

function variantExists(array, variantId) {
    return array.some(item => item.variant_id === variantId);
}

function countByKeyValuePair(array, key, value) {
    return array.filter(item => item[key] === value).length;
}

// READ BTN -- START

jQuery(document).ready(function(){
   function AddReadMore() {
    //This limit you can set after how much characters you want to show Read More.
    var carLmt = 150;
    // Text to show when text is collapsed
    var readMoreTxt = " ...read more";
    // Text to show when text is expanded
    var readLessTxt = " read less";
    //Traverse all selectors with this class and manupulate HTML part to show Read More
    $(".add-read-more").each(function () {
       if ($(this).find(".first-section").length)
          return;
       var allstr = $(this).text();
       if (allstr.length > carLmt) {
          var firstSet = allstr.substring(0, carLmt);
          var secdHalf = allstr.substring(carLmt, allstr.length);
          var strtoadd = firstSet + "<span class='second-section'>" + secdHalf + "</span><span class='read-more'  title='Click to Show More'>" + readMoreTxt + "</span><span class='read-less' title='Click to Show Less'>" + readLessTxt + "</span>";
          $(this).html(strtoadd);
       }
    });
    //Read More and Read Less Click Event binding
    $(document).on("click", ".read-more,.read-less", function () {
       $(this).closest(".add-read-more").toggleClass("show-less-content show-more-content");
    });
 }
 AddReadMore();
});

// READ BTN -- END


// bundle-builder.liquid =========== START
document.addEventListener("DOMContentLoaded", function() {
  const tabs = document.querySelectorAll(".bn_col_box");
  const steps = document.querySelectorAll(".pod_steps");
  const nextButton = document.querySelector(".footer-next-button");
  const prevButton = document.querySelector(".footer-previous-button");
  const progressFill = document.querySelector(".bn_progress_fill");
  const totalSteps = steps.length;
  let currentStep = 0;

  // Function to show the active step, update progress bar, and mark completed steps
  function showStep(index) {
    steps.forEach(step => step.classList.remove("active"));
    tabs.forEach((tab, tabIndex) => {
      tab.classList.remove("active", "step-fill");
      if (tabIndex < index) {
        tab.classList.add("step-fill"); // Add step-fill to completed steps
      }
    });

    if (steps[index]) {
      steps[index].classList.add("active");
      tabs[index].classList.add("active");
      currentStep = index;

      // Update progress bar width
      const progressWidth = ((currentStep + 1) / totalSteps) * 100;
      progressFill.style.width = `${progressWidth}%`;
    }
  }
  // Initialize first step as active and set progress
  showStep(0);
});

// bundle-builder.liquid =========== END


jQuery(document).on("click",".cw-popup-bottom__close",function(e){
  /*var popUpBlock = $(this).parent().parent().parent().parent().find(".product-popup-modal__content");
  var popUpInfo = popUpBlock.find(".product-popup-modal__content-info");
  var findClose = popUpBlock.find(".product-popup-modal__toggle");
  popUpInfo.scrollTop(0);
  findClose.trigger("click");*/
  var popUpBlock = $(this).parents(".product-popup-modal__content");
  var popUpInfo = $(this).parents(".product-popup-modal__content-info");
  var findClose = popUpBlock.find(".product-popup-modal__toggle");
  popUpInfo.scrollTop(0);
  findClose.trigger("click");
  e.preventDefault();
});